export type IconName =
  | 'layers'
  | 'nodes'
  | 'target'
  | 'linux'
  | 'win'
  | 'apple'
  | 'folder'
  | 'tabs'
  | 'split'
  | 'archive'
  | 'user'
  | 'grid'

export const IconSprite = () => {
  return (
    <svg
      width="0"
      height="0"
      style={{ position: 'absolute' }}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <symbol id="layers" viewBox="0 0 24 24">
          <path d="M12 3 3 8l9 5 9-5z" />
          <path d="m3 12 9 5 9-5" />
          <path d="m3 16 9 5 9-5" />
        </symbol>
        <symbol id="nodes" viewBox="0 0 24 24">
          <circle cx="18" cy="5" r="2.5" />
          <circle cx="6" cy="12" r="2.5" />
          <circle cx="18" cy="19" r="2.5" />
          <path d="m8.2 10.8 7.6-4.6M8.2 13.2l7.6 4.6" />
        </symbol>
        <symbol id="target" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="5" />
          <circle cx="12" cy="12" r="1.2" />
        </symbol>
        <symbol id="linux" viewBox="0 0 24 24">
          <path d="M12 2.5c-2.2 0-3.4 1.8-3.4 4 0 1.2-.5 2-1.3 3.2C6 11.5 5 13.5 5 15.6c0 1.2.5 2 1.2 2.5L5 20.5l3.2.3c.8.9 2.2 1.2 3.8 1.2s3-.3 3.8-1.2l3.2-.3-1.2-2.4c.7-.5 1.2-1.3 1.2-2.5 0-2.1-1-4.1-2.3-5.9-.8-1.2-1.3-2-1.3-3.2 0-2.2-1.2-4-3.4-4z" />
          <path d="M10 7.3h.01M14 7.3h.01M10.5 9.2h3l-1.5 1.2z" />
        </symbol>
        <symbol id="win" viewBox="0 0 24 24">
          <path
            className="f"
            d="M3 5.4 10.5 4.4v7H3zM11.6 4.2 21 3v8.4h-9.4zM3 12.6h7.5v7L3 18.6zM11.6 12.6H21V21l-9.4-1.2z"
          />
        </symbol>
        <symbol id="apple" viewBox="0 0 24 24">
          <path
            className="f"
            d="M16.4 12.6c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9s-1.8-.8-3-.8c-1.6 0-3.1.9-3.9 2.3-1.7 2.9-.4 7.2 1.2 9.6.8 1.1 1.7 2.4 3 2.4 1.2 0 1.6-.8 3.1-.8s1.8.8 3 .8c1.3 0 2.1-1.2 2.9-2.3.9-1.3 1.3-2.6 1.3-2.7 0 0-2.5-1-2.7-4.2zM14.1 5.6c.6-.8 1.1-1.8.9-2.9-.9 0-2 .6-2.7 1.4-.6.7-1.1 1.8-1 2.8 1 .1 2.1-.5 2.8-1.3z"
          />
        </symbol>
        <symbol id="folder" viewBox="0 0 24 24">
          <path d="M3 6.5A1.5 1.5 0 0 1 4.5 5H9l2 2.5h8.5A1.5 1.5 0 0 1 21 9v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18z" />
        </symbol>
        <symbol id="tabs" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="16" rx="2.5" />
          <path d="M3 9h18M7 6.5h.01" />
          <path d="M13 14h4" />
        </symbol>
        <symbol id="split" viewBox="0 0 24 24">
          <rect x="3" y="3.5" width="18" height="17" rx="2.5" />
          <path d="M12 3.5v17" />
        </symbol>
        <symbol id="archive" viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="4.5" rx="1" />
          <path d="M4.5 8.5V19a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8.5M10 13h4" />
        </symbol>
        <symbol id="user" viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="4" />
          <path d="M4.5 21c.5-4 3.5-6 7.5-6s7 2 7.5 6" />
        </symbol>
        <symbol id="grid" viewBox="0 0 24 24">
          <rect x="3.5" y="3.5" width="7" height="7" rx="1.5" />
          <rect x="13.5" y="3.5" width="7" height="7" rx="1.5" />
          <rect x="3.5" y="13.5" width="7" height="7" rx="1.5" />
          <rect x="13.5" y="13.5" width="7" height="7" rx="1.5" />
        </symbol>
      </defs>
    </svg>
  )
}

export const Icon = ({
  name,
  isFilled = false,
  className = '',
}: {
  name: IconName
  isFilled?: boolean
  className?: string
}) => {
  return (
    <svg
      className={`i${isFilled ? ' f' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden="true"
      focusable="false"
    >
      <use href={`#${name}`} />
    </svg>
  )
}
